/* FYP NAVIGATION MODERNISATION — 5 Aug 2026 · r4
   Navigation analytics (dataLayer) + Escape dismissal + feature carousels.
   Carousel standards: auto-advance 4s default (block setting 3–8s), runs ONLY
   while its menu is open, pauses on hover/focus, explicit pause/play control
   (WCAG 2.2.2), fully static under prefers-reduced-motion.
   Events inert until a tag manager subscribes. No UTMs. */
(function () {
  'use strict';
  var VERSION = 'nav-2026-08';
  if (window.Shopify && window.Shopify.designMode) return;

  var dl = (window.dataLayer = window.dataLayer || []);
  var themeId = window.Shopify && Shopify.theme ? String(Shopify.theme.id) : '';
  var themeRole = window.Shopify && Shopify.theme ? String(Shopify.theme.role) : '';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastKey = '', lastAt = 0;

  function deviceClass() {
    return window.matchMedia && window.matchMedia('(max-width: 999px)').matches ? 'mobile' : 'desktop';
  }

  function push(eventName, extra) {
    var key = eventName + '|' + JSON.stringify(extra);
    var now = Date.now();
    if (key === lastKey && now - lastAt < 200) return;
    lastKey = key; lastAt = now;
    var payload = { event: eventName, menu_version: VERSION, device_class: deviceClass(), theme_id: themeId, theme_role: themeRole };
    for (var k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k] != null && extra[k] !== '') payload[k] = extra[k];
    }
    dl.push(payload);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Feature carousels ---------- */
  function initCarousel(root) {
    var slides = [].slice.call(root.querySelectorAll('.fyp-mm-carousel__slide'));
    if (slides.length < 2) return;
    var speed = parseInt(root.getAttribute('data-fyp-speed'), 10) || 4000;
    if (speed < 3000) speed = 3000;
    var toggle = root.querySelector('[data-fyp-carousel-toggle]');
    var det = root.closest('details');
    var idx = 0, timer = null, hoverPause = false, userPause = false;

    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === idx;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('tabindex', '-1'); }
      });
    }

    function running() {
      return !reduced && !hoverPause && !userPause && (!det || det.open) && !document.hidden;
    }

    function tick() {
      stop();
      if (!running()) return;
      timer = window.setInterval(function () {
        if (!running()) { stop(); return; }
        show(idx + 1);
      }, speed);
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    if (reduced) { if (toggle) toggle.style.display = 'none'; show(0); return; }

    root.addEventListener('mouseenter', function () { hoverPause = true; stop(); });
    root.addEventListener('mouseleave', function () { hoverPause = false; tick(); });
    root.addEventListener('focusin', function () { hoverPause = true; stop(); });
    root.addEventListener('focusout', function () { hoverPause = false; tick(); });

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        userPause = !userPause;
        toggle.setAttribute('aria-pressed', String(userPause));
        toggle.setAttribute('aria-label', userPause ? 'Play product carousel' : 'Pause product carousel');
        toggle.classList.toggle('is-paused', userPause);
        if (userPause) stop(); else tick();
      });
    }

    if (det) det.addEventListener('toggle', function () { if (det.open) tick(); else stop(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else tick(); });
    tick();
  }

  ready(function () {
    var header = document.querySelector('.shopify-section--header');
    if (!header) return;

    /* FYP Header v3 (17 Aug 2026): tag the New In item so the CSS can
       remove it from the rail, and lift the utility-bar links (Find My
       Gear · Gear Compare · Learn · The Showroom) into the logo row so
       the desktop header is two rows, not three. Clones, no moves —
       without JS the original third-row bar simply stays. */
    (function(){ try {
      var linkList = header.querySelector('.header__main-nav .header__link-list');
      if (linkList) {
        [].slice.call(linkList.querySelectorAll(':scope > ul > li')).forEach(function(li){
          var a = li.querySelector('summary, a');
          if (a && (a.textContent || '').trim().toLowerCase().indexOf('new in') === 0) li.classList.add('fyp-newin');
        });
        document.documentElement.classList.add('fyp-v3-ready');
      }
      var wrapper = header.querySelector('.header__wrapper');
      var ub = document.querySelector('.shopify-section--fyp-utility-bar .fyp-ub__inner');
      if (wrapper && ub && !wrapper.querySelector('.fyp-utils-top')) {
        var nav = document.createElement('nav');
        nav.className = 'fyp-utils-top';
        nav.setAttribute('aria-label', 'Utility');
        [].slice.call(ub.querySelectorAll('a.fyp-ub__link')).forEach(function(a){
          var c = a.cloneNode(true);
          c.className = '';
          nav.appendChild(c);
        });
        if (nav.childNodes.length) {
          var logo = wrapper.querySelector('.header__logo');
          if (logo && logo.nextSibling) wrapper.insertBefore(nav, logo.nextSibling); else wrapper.appendChild(nav);
          document.documentElement.classList.add('fyp-utils-lifted');
        }
      }
    } catch(e){} })();

    /* 2 Oct 2026 audit-fix (FYP-018): on the stacked desktop header (>=1024px)
       the department rail is the FIRST grid item in the DOM but renders in the
       SECOND row. Impact's reading-flow:grid-rows was meant to reconcile that,
       but in Chromium it skipped the logo, utility links, Search, Login and
       Cart entirely. fyp-pass1.css now sets reading-flow:normal at >=1024px and
       this moves the rail after the icon cluster so DOM order = visual order
       (logo -> utilities -> icons -> rail). Below 1024px the rail is put back
       first, exactly as Impact ships it, so the mobile order is unchanged. */
    (function(){ try {
      var wrapper = header.querySelector('.header__wrapper');
      var rail = wrapper && wrapper.querySelector(':scope > .header__main-nav');
      if (!wrapper || !rail || !window.matchMedia) return;
      var mq = window.matchMedia('(min-width: 1024px)');
      var place = function(){
        if (mq.matches) { if (wrapper.lastElementChild !== rail) wrapper.appendChild(rail); }
        else if (wrapper.firstElementChild !== rail) wrapper.insertBefore(rail, wrapper.firstElementChild);
      };
      place();
      if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    } catch(e){} })();

    /* 2 Oct 2026 audit-fix (FYP-031): the sidebar menu drawer is role=dialog
       with no accessible name. Name it "Menu" (the hamburger's own label) and
       name each desktop mega drawer after its department, without touching
       focus or Escape handling. */
    (function(){ try {
      var side = document.getElementById('header-sidebar-menu');
      if (side && !side.hasAttribute('aria-label') && !side.hasAttribute('aria-labelledby')) {
        var opener = header.querySelector('[aria-controls="header-sidebar-menu"] .sr-only');
        side.setAttribute('aria-label', (opener && opener.textContent.trim()) || 'Menu');
      }
      header.querySelectorAll('navigation-drawer[id^="navigation-drawer-"]').forEach(function(d){
        if (d.hasAttribute('aria-label')) return;
        var t = header.querySelector('[aria-controls="' + d.id + '"]');
        if (t && t.textContent.trim()) d.setAttribute('aria-label', t.textContent.trim());
      });
    } catch(e){} })();

    header.querySelectorAll('[data-fyp-carousel]').forEach(initCarousel);

    header.querySelectorAll('.header__link-list details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s && !d.dataset.fypDept) d.dataset.fypDept = (s.textContent || '').trim();
      d.addEventListener('toggle', function () {
        if (d.open) push('fyp_nav_open', { department: d.dataset.fypDept });
      });
    });

    /* WCAG 1.4.13 dismissal patch: close open header menus on Escape, focus returns to trigger. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = header.querySelectorAll('.header__link-list details[open]');
      if (!open.length) return;
      open.forEach(function (d) {
        d.open = false;
        var s = d.querySelector('summary');
        if (s && (d.contains(document.activeElement) || document.activeElement === document.body)) s.focus();
      });
    });

    function classify(a) {
      if (a.dataset.fypNav) return a.dataset.fypNav;
      if (a.closest('.fyp-utils-top')) return 'tool';
      if (a.closest('.fyp-mega-tools')) return 'tool';
      if (a.closest('.fyp-mega-cta') || a.classList.contains('fyp-mega-cta')) return 'shop_all';
      if (a.closest('.mega-menu')) {
        return a.getAttribute('href') && a.getAttribute('href').indexOf('/products/') !== -1 ? 'feature_product' : 'category';
      }
      if (a.closest('.header__link-list')) return 'top_level';
      if (a.closest('.navigation-drawer')) return 'category';
      return null;
    }

    function positionOf(a) {
      var li = a.closest('li');
      if (!li || !li.parentElement) return null;
      var idx = 0, n = li;
      while ((n = n.previousElementSibling)) idx++;
      return idx + 1;
    }

    function onClick(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var type = classify(a);
      if (!type) return;
      var deptEl = a.closest('[data-fyp-dept]');
      var dept = a.dataset.fypDept || (deptEl ? deptEl.dataset.fypDept : '') || (a.closest('.navigation-drawer') ? 'mobile-drawer' : '');
      push('fyp_nav_click', {
        department: dept,
        label: (a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 60),
        link_type: type,
        position: positionOf(a),
        destination: a.getAttribute('href')
      });
    }

    header.addEventListener('click', onClick);
    document.querySelectorAll('.navigation-drawer').forEach(function (d) {
      d.addEventListener('click', onClick);
    });
    document.querySelectorAll('button[aria-controls="header-sidebar-menu"]').forEach(function (b) {
      b.addEventListener('click', function () {
        push('fyp_nav_open', { department: 'mobile-drawer' });
      });
    });
  });
})();
